export const getPolyEnc = (polyEnc?: string | string[]) => {
    if (!polyEnc) {
        return '';
    }

    if (typeof polyEnc === 'string') {
        return polyEnc;
    }

    if (Array.isArray(polyEnc)) {
        return polyEnc.join('&polyenc=');
    }

    return '';
};
